import instanceConfig from '../utils/instanceConfig';
import urlUtil from '../utils/url';
import HeaderLogo from '../layout/HeaderLogo';

export default {
  props: ['logoUrlOverride'],
  components: {
    HeaderLogo,
  },

  data() {
    return {
      globalLogoUrl: '',
      logoUrl: '',
    };
  },

  created() {
    if (typeof this.logoUrlOverride !== 'undefined') {
      this.logoUrl = this.logoUrlOverride;
      this.globalLogoUrl = this.logoUrlOverride;
    } else {
      instanceConfig.get().then(config => {
        this.globalLogoUrl = config['global-logo-url']
          ? urlUtil.randomize(config['global-logo-url'])
          : '';
        this.logoUrl = config['logo-url']
          ? urlUtil.randomize(config['logo-url'])
          : '';
      }).catch(() => {});
    }
  },

  methods: {
    onLogoClick() {
      this.$emit('logoClick');
    },
  },

  watch: {
    logoUrlOverride(newVal) {
      this.logoUrl = newVal;
      this.globalLogoUrl = newVal;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/page-with-logo.js